import { walk } from "src/components/TreeStd";
import { ZAttrLabelTreeData } from "../types/ZAttrLabelTreeData";

export const getLeaves = (treeData: ZAttrLabelTreeData) => {
  const leaves: ZAttrLabelTreeData[] = [];
  walk(
    (node) => {
      if (!node.children) leaves.push(node);
    },
    [treeData],
  );
  return leaves;
};
